import { FC, SVGProps } from 'react';

export const MoneyIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M2.90671 11.2845C3.69831 9.96704 4.55242 8.67083 5.38087 7.37346L3.1166 3.13634C3.1166 3.13634 3.28966 2.98783 3.72175 2.65288C5.01355 1.6525 6.42704 1.39347 7.95549 1.98745C9.41147 2.55352 10.8886 2.98226 12.4695 2.89293C12.9296 2.86614 14.6947 2.63168 14.6947 2.63168L12.6213 7.36564C13.4498 8.6619 14.3017 9.96704 15.0933 11.2845C16.3951 13.4506 17.64 15.8667 16.6318 18.3811C15.4584 21.3085 12.0352 22.2799 8.99939 22.3279C5.9648 22.2799 2.54161 21.3085 1.36817 18.3811C0.359964 15.8667 1.60486 13.4506 2.90671 11.2845Z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.5731 12.3811H8.30217C7.62662 12.3811 7.07959 12.9282 7.07959 13.6037C7.07959 14.2792 7.62662 14.8274 8.30217 14.8274H9.69997C10.3755 14.8274 10.9225 15.3744 10.9225 16.05C10.9225 16.7254 10.3755 17.2726 9.69997 17.2726H7.42901"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9 17.274V18.3011M9 11.3501V12.3862"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.38037 7.38306C7.7942 7.93796 10.207 7.93796 12.6209 7.38306"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
